module.exports = __webpack_public_path__ + "img/Aston_University3.b49ed94c.jpg";